import { animate, style, transition, trigger } from "@angular/animations";
import {
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  ViewChild,
  HostListener, Directive
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { Subscription, timer } from "rxjs";
import { Projectcomment } from "@src/app/models/comment";
import { Task } from "@src/app/models/task";
import { FooterService } from "./service/footer.service";
import "quill-mention/autoregister";
import { Projectmember } from "./model/projectmember";
import { PersonOrganization } from "@src/app/models/personorganization";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";
import { CustomerUser } from "@src/app/models/customeruser";
import { QuillEditorComponent } from 'ngx-quill';
//import "@src/quill2-emoji/quill-emoji.js";
import Quill from 'quill';
// import {
// // ShortNameEmoji
// // EmojiBlot
// // ToolbarEmoji
//   TextAreaEmoji }from "@windmillcode/quill-emoji";
//   Quill.register('modules/emoji-textarea', TextAreaEmoji,true)

import { PushNotificationService } from "@src/app/helpers/push-notification.service";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],

  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0, zIndex: 4, position: "absolute" }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 0, zIndex: 4, position: "absolute" }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})

export class FooterComponent implements OnInit {
  year: string;
  @Input() mobilefooter:boolean;
  chatswitch: boolean;
  showMsg: boolean;
  showFilters: boolean;
  showOptions: string;
  newComment: Projectcomment;
  newTaskComment: Projectcomment;
  commentsList: Projectcomment[];
  taskCommentsList: Projectcomment[];
  showTaskComments: boolean;
  childcommentList: Projectcomment[];
  @Input() allcommentsList: Projectcomment[];
  replymodalId: string;
  personId: string;
  newCommentReply: Projectcomment;
  choosenComment: Projectcomment;
  modalTask: Task;
  name = "Angular";
  message = "";

  private chatlistholder: ElementRef;
  @ViewChild("chatlist", { static: false }) chatlist: ElementRef;
  @ViewChild("closechat", { static: false }) closechat: ElementRef;
  subscription: Subscription;
  listLenght: number;
  showFooter: boolean;
  showNotificationList: boolean;
  showChatList: boolean;
  showProjectList: boolean;
  currentProjectName: string;
  filterByTask: boolean;
  filteredTaskId: string;
  setTaskSubscription: Subscription;
  setShowNotification: Subscription;
  notificationSubsription: Subscription;
  currentProjectSubscription: Subscription;
  closechatSubscription: Subscription;
  showOrgChooser: Subscription;
  currentProjectId: string;
  members: Projectmember[];
  allmembers: Projectmember[];
  placeholdertext: string;
  timerActive: boolean = false;
  @ViewChild(QuillEditorComponent, { static: true })
  editor: QuillEditorComponent;
  blured = false;
  focused = false;
  private el: ElementRef;
  quilleditor: any;
  filterfolded: boolean;
  replyOpen: boolean;
  orglist: PersonOrganization[];
  et_admin: boolean;
  customerUsers: CustomerUser[];
  scollToBottomTimeout: any;
  private readonly fsrv = inject(FooterService);
  private readonly uievent = inject(UieventhubService);
  private readonly auth = inject(AuthorizationService);
  private readonly router = inject(Router);
  private readonly datastore = inject(DatastoreService);
  private readonly pushNotifications = inject(PushNotificationService);

  private normalizeTaskId(taskId: string | undefined | null): string {
    if (!taskId) {
      return '';
    }

    return String(taskId).split('_')[0];
  }

  private getVisibleTopLevelComments(): Projectcomment[] {
    const source = Array.isArray(this.allcommentsList) ? this.allcommentsList : [];
    const topLevel = source.filter((comment) => !comment.parent_comment);

    if (!this.filterByTask || !this.modalTask || !this.modalTask.taskId) {
      return topLevel;
    }

    const selectedTaskId = this.normalizeTaskId(this.modalTask.taskId);
    return topLevel.filter((comment) => this.normalizeTaskId(comment.related_task) === selectedTaskId);
  }

  private refreshVisibleComments(shouldScroll = true): void {
    const newCommentsList = this.getVisibleTopLevelComments();
    
    // Only update if content actually changed
    if (!this.isCommentsListEqual(this.commentsList, newCommentsList)) {
      this.commentsList = newCommentsList;
      
      if (shouldScroll && (this.listLenght === 0 || this.commentsList.length !== this.listLenght)) {
        this.scrollToBottum();
      }

      this.listLenght = this.commentsList.length;
    }
  }

  private isCommentsListEqual(list1: Projectcomment[], list2: Projectcomment[]): boolean {
    if (!list1 && !list2) return true;
    if (!list1 || !list2 || list1.length !== list2.length) return false;
    
    return list1.every((comment1, index) => {
      const comment2 = list2[index];
      return comment1?.commentId === comment2?.commentId && 
             comment1?.projectcomment === comment2?.projectcomment &&
             comment1?.creator === comment2?.creator &&
             comment1?.created === comment2?.created;
    });
  }

  trackByCommentId(index: number, comment: Projectcomment): string {
    return comment?.commentId || index.toString();
  }
  

  // modules = {
  //   mention: {
  //     allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
  //     //   onSelect: (item, insertItem) => {
  //     //   const editor = this.editor.quillEditor
  //     //   insertItem(item)
  //     //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
  //     //   editor.insertText(editor.getLength() - 1, '', 'user')
  //     //  },
  //     source: (searchTerm, renderList) => {
  //       const members = this.members;
  //       const values = [];
  //       for (let index = 0; index < members.length; index++) {
  //         values.push({
  //           id: members[index].personId
  //             ? members[index].personId
  //             : members[index].userId,
  //           value: members[index].fullname,
  //         });
  //       }
  //       for (let customerUser of this.customerUsers) {
  //         values.push({
  //           id: customerUser.userId,
  //           value: customerUser.fullname,
  //         });
  //       } 

  //       if (searchTerm.length === 0) {
  //         renderList(values, searchTerm);
  //       } else {
  //         const matches = [];

  //         values.forEach((entry) => {
  //           if (
  //             entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
  //           ) {
  //             matches.push(entry);
  //           }
  //         });
  //         renderList(matches, searchTerm);
  //       }
  //     },
  //   },
  //   "emoji-shortname": true,
  //   "emoji-textarea": true,
  //   "emoji-toolbar": true,
  //   toolbar: [["bold", "italic", "underline", "strike"], ["link"], ["emoji"]],
  // };
  formats = [
    'background',
    'bold',
    'color',
    'font',
    'code',
    'italic',
    'link',
    'size',
    'strike',
    'script',
    'underline',
    'blockquote',
    'header',
    'indent',
    'list',
    'align',
    'direction',
    'code-block',
    'formula',
    'mention'
    // 'image'
    // 'video'
  ];
  modules = {}
  content = ''
  matContent = ''
    constructor() {
      this.modules = {
        mention: {
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          //   onSelect: (item, insertItem) => {
          //   const editor = this.editor.quillEditor
          //   insertItem(item)
          //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
          //   editor.insertText(editor.getLength() - 1, '', 'user')
          //  },
          source: (searchTerm, renderList) => {
            const members = this.members;
            const values = [];
            for (let index = 0; index < members.length; index++) {
              values.push({
                id: members[index].personId
                  ? members[index].personId
                  : members[index].userId,
                value: members[index].fullname,
              });
            }
            for (let customerUser of this.customerUsers) {
              values.push({
                id: customerUser.userId,
                value: customerUser.fullname,
              });
            } 
    
            if (searchTerm.length === 0) {
              renderList(values, searchTerm);
            } else {
              const matches = [];
    
              values.forEach((entry) => {
                if (
                  entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
                ) {
                  matches.push(entry);
                }
              });
              renderList(matches, searchTerm);
            }
          },
        },
        //TextAreaEmoji: true,
        //"emoji-textarea": true,
    toolbar: [["bold", "italic", "underline", "strike"], ["link"]],
      }

    
  
    // this.filterfolded = false;
    // this.showChatList = false;
    // this.showNotificationList = false;
    // this.showProjectList = false;
    // if (SessionHelper.getCurrentProject()) {
    //   this.showChatList = true;
    // } else {
    //   this.showProjectList = true;
    // }
    this.setTaskSubscription = this.uievent.chatTask$.pipe(untilDestroyed(this)).subscribe((tid) => {
      //console.log('call from service: ',tid);
      if (tid != "") {
        this.setFilterByTask(tid);
      } else {
        this.removeFilterByTask();
      }
      this.setShowChatList();
    });

    this.setShowNotification = this.uievent.showNotification$.pipe(untilDestroyed(this)).subscribe(
      (show) => {
        //console.log("show notification", show);
        if (show == "show") {
          this.setShowNotificationList();
        } else {
          if(SessionHelper.getChatShow() == "project"){
            this.setShowProjectList();
          }else{
            this.setShowChatList();
          }
          
        }
      }
    );
    this.notificationSubsription = this.uievent.notifications$.pipe(untilDestroyed(this)).subscribe(
      (notf) => {
        this.getChat();
      }
    );

    this.currentProjectSubscription = this.uievent.currentProject$.pipe(untilDestroyed(this)).subscribe(
      (projectId) => {
        this.currentProjectId = projectId;
        //this.currentProjectName = JSON.parse(SessionHelper.getCurrentProjectFull()).title;
        this.getChat();
      }
    );


  }
  contentChanged(event) { 
    this.newComment.projectcomment = event.html;
  }

  hideSidePanel() {
    SessionHelper.setChatShow("false");
    this.uievent.setshowchatcollapse(false);
    this.showFooter = false;
    
    // Stop timer when hiding panel
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.timerActive = false;
    }
  }

  toggleListLenght() {
    this.filterfolded = !this.filterfolded;
  }
  
  ngAfterViewInit() {
    const domEvent = new CustomEvent('unselect', { bubbles: true });  
    if(this.el){
      this.el.nativeElement.dispatchEvent(domEvent);
    }
   // this.el.nativeElement.dispatchEvent(domEvent);
  }

  setShowChatList() {
    this.showNotificationList = false;
    this.showProjectList = false;
    this.showChatList = true;
    this.showFooter = true;
    this.getChat();
    this.scrollToBottum();
  }

  setShowNotificationList() {
    this.showChatList = false;
    this.showProjectList = false;
    this.showNotificationList = true;
    this.showFooter = true;
  }

  setShowProjectList() {
    this.showChatList = false;
    this.showProjectList = true;
    this.showNotificationList = false;
    this.showFooter = true;
  }

  openProject(projectId: string) {
    this.showProjectList = false;
    this.showNotificationList = false;
    this.showChatList = true;
    this.currentProjectId = projectId;
    this.uievent.setCurrentProject(projectId);
    this.showFooter = true;
    
    // Stop existing timer before switching projects
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.timerActive = false;
    }
    
    this.getChat();
    this.scrollToBottum();
  }

  gotoList() {
    this.showChatList = false;
    this.showNotificationList = false;
    this.showProjectList = true;
    this.uievent.setCurrentProject("");
    
    // Stop timer when leaving project view
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.timerActive = false;
    }
   //console.log(SessionHelper.getCustomer());
  
    if(SessionHelper.getCustomer()){
      if(JSON.parse(SessionHelper.getCustomer()).customerType === 'light') {
        this.router.navigateByUrl("/customerlight");
        return;
      }
      this.router.navigateByUrl("/customerportal");
    }else{
    this.router.navigateByUrl("/portal");
    } 
  }

  ngOnInit() {
    //console.log("footer init"); 
    if (SessionHelper.getChoosenOrg()) {
      let s = SessionHelper.getChatShow();
      if(s == "notification" && !this.showNotificationList){
        this.showFooter = true;
        this.setShowNotificationList();
      } else if(s == "chat" && !this.showChatList){
        this.showFooter = true;
        this.setShowChatList();
      }else if(s == "project" && !this.showProjectList){
        this.showFooter = true;
        this.setShowProjectList();
      }else{
        this.showFooter = false;
      }
     
    
    //console.log("footer init");

    this.fsrv.getOrg(SessionHelper.getChoosenOrg()).subscribe((o) => {
      if (o.modules && o.modules.indexOf("hubspot") > 0) {
        SessionHelper.setHubspot();
      }else{
        SessionHelper.clearHubspot();
      }
    });
    if (SessionHelper.getPerson()) {
      const person = JSON.parse(SessionHelper.getPerson());
      this.et_admin = person.et_admin;
    }
    if (SessionHelper.getCurrentProject() != null) {
      this.currentProjectId = SessionHelper.getCurrentProject();
      this.datastore.projectpersonList$.pipe(untilDestroyed(this)).subscribe((mem) => {
        this.allmembers = mem;
        this.members = this.allmembers.filter(x => x.projectId == this.currentProjectId);

      });
      this.datastore.customersUsers$.pipe(untilDestroyed(this)).subscribe((cusmem) => {
        let cust = JSON.parse(SessionHelper.getCurrentProjectFull()).customer;
        this.customerUsers = cusmem.filter(x => x.customerId == cust);
      });

      this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tasks) => {
        if (!this.filterByTask || !this.filteredTaskId) {
          return;
        }

        const selectedTask = tasks.find(
          (task) => this.normalizeTaskId(task.taskId) === this.normalizeTaskId(this.filteredTaskId)
        );

        if (selectedTask) {
          this.modalTask = selectedTask;
          this.refreshVisibleComments(false);
        }
      });
    } 

    this.placeholdertext = "footer.message";
    this.showOptions = "";
    this.replymodalId = "";
    this.listLenght = 0;
    this.allcommentsList = [];
    this.chatswitch = false;
    this.year = new Date().getFullYear().toString();
    this.modalTask = new Task();
    this.commentsList = [];
    this.taskCommentsList = [];
    this.newComment = new Projectcomment();
    this.newCommentReply = new Projectcomment();
    this.newTaskComment = new Projectcomment();
    this.choosenComment = new Projectcomment();
    this.childcommentList = [];
    this.showFilters = false;
    this.showTaskComments = true;
    this.personId = SessionHelper.getUserSub();
    //this.setTimer(1000); //init with one sec
    //this.getChat();
    this.filterByTask = false;
    this.filteredTaskId = '';
    this.initPushNotifications();

 
  }
  }

  enterToSend() {
    if (this.replymodalId == "") {
      if (this.modalTask.taskId == undefined || this.modalTask.taskId == "") {
        this.saveComment();
      } else {
        this.saveTaskComment();
      }
    } else {
      this.savecommentReply();
    }
  }

  focus($event) {
    //console.log('This focus',$event);
  }

  setFocus(editor) {
    this.quilleditor = editor;
    this.quilleditor.focus();
  }

  initPushNotifications() {
    this.pushNotifications.init(() => {
      this.getChat();
    });
  }

  getChat() {
    if (SessionHelper.getCurrentProject()) {
      // Only start timer if one isn't already running
      if (!this.timerActive) {
        this.timerActive = true;
        this.setTimer(3000);
      }
      
      //console.log('getChat',SessionHelper.getCurrentProjectName());
      //console.log('getChat',SessionHelper.getCurrentProject());
      this.currentProjectId = SessionHelper.getCurrentProject();
      
      this.allmembers = this.datastore.projectpersonList.getValue();
      this.members = this.allmembers.filter(x => x.projectId == this.currentProjectId);
      
      let cust = JSON.parse(SessionHelper.getCurrentProjectFull()).customer;
      //console.log('customer id',cust);
      this.customerUsers = this.datastore.customersUsers.getValue().filter(x => x.customerId == cust);
    }
  }

  setTimer(interval: number) {
    const ping = timer(interval);
    this.subscription = ping.subscribe(() => {
      if (SessionHelper.getCurrentProject()) {
        this.fsrv.getComments(SessionHelper.getCurrentProject()).subscribe(cl => {
          const sortedComments = cl.sort((a, b) => new Date(a.created).valueOf() - new Date(b.created).valueOf());
          const hadCountChange = this.allcommentsList.length !== sortedComments.length;
          
          // Only update if content actually changed
          if (!this.isCommentsListEqual(this.allcommentsList, sortedComments)) {
            this.allcommentsList = sortedComments;
            this.refreshVisibleComments();
          }

          // Adjust polling interval based on whether comments changed
          let nextInterval = interval;
          if (hadCountChange) {
            if (nextInterval > 1000) {
              nextInterval = 1000;
            }
          } else {
            if (nextInterval < 30000) {
              nextInterval = nextInterval + 1000;
            }
          }
          //console.log('interval ', nextInterval);
          this.setTimer(nextInterval);
        });
      }
    });
  }
  // ngAfterViewChecked() {

  //   //this.currentProjectName = JSON.parse(SessionHelper.getCurrentProjectFull()).title;
  //   if (!SessionHelper.getChoosenOrg()) {
  //     this.showFooter = false;
  //   } else {
  //     if (SessionHelper.getCurrentProject()) {
  //       this.showFooter = true;
  //       if (this.notificationSubsription. == true) {
  //         this.getChat();
  //       }
  //     }
  //   }
  // }
  ngOnDestroy(): void {
    if(this.scollToBottomTimeout) clearTimeout(this.scollToBottomTimeout);
    if (this.subscription) this.subscription.unsubscribe();
    if (this.setTaskSubscription) this.setTaskSubscription.unsubscribe();
    if (this.currentProjectSubscription)
      this.currentProjectSubscription.unsubscribe();
    if (this.notificationSubsription)
      this.notificationSubsription.unsubscribe();
    if (this.closechatSubscription) this.closechatSubscription.unsubscribe();
  }

  saveComment() {
    //console.log('Save comment method',this.newComment.projectcomment);
    //this.newComment.parent_comment = "01527e70-7b91-11eb-a42e-87af83786f1b";
    this.newComment.projectId = SessionHelper.getCurrentProject();
    this.newComment.creator = SessionHelper.getUserSub();
    this.newComment.commentvisibility = "shared";
    this.newComment.created = new Date();
    if (SessionHelper.getCustomer()) {
      this.newComment.comment_type = "customer";
    } else {
      this.newComment.comment_type = "organization";
    }
    this.newComment.organizationId = SessionHelper.getChoosenOrg();
    this.fsrv.saveComment(this.newComment).pipe(untilDestroyed(this)).subscribe((pc) => {
      this.newComment.commentId = pc;
      this.allcommentsList.push(JSON.parse(JSON.stringify(this.newComment)));
      this.refreshVisibleComments(false);
      //console.log(this.commentsList);
      this.uievent.setProjectComments(this.newComment.projectId);
      this.newComment = new Projectcomment();
      this.scrollToBottum();
    });
  }

  deleteComment() {
    this.fsrv
      .deleteComment(
        SessionHelper.getCurrentProject(),
        this.choosenComment.commentId
      )
      .pipe(untilDestroyed(this)).subscribe((result) => {
        //console.log(result);
        this.commentsList.splice(
          this.commentsList.indexOf(this.choosenComment),
          1
        );
        this.scrollToBottum();
      });
  }

  savecommentReply() {
    this.newCommentReply.parent_comment = this.replymodalId; //Assign reply id
    this.newCommentReply.projectId = SessionHelper.getCurrentProject();
    this.newCommentReply.creator = SessionHelper.getUserSub();
    this.newCommentReply.projectcomment = this.newComment.projectcomment;
    this.newCommentReply.commentvisibility = this.modalTask.taskvisibility
      ? this.modalTask.taskvisibility
      : "shared";
    this.newCommentReply.related_task = this.modalTask.taskId
      ? this.modalTask.taskId
      : "";

    this.newCommentReply.created = new Date();
    if (SessionHelper.getCustomer()) {
      this.newCommentReply.comment_type = "customer";
    } else {
      this.newCommentReply.comment_type = "organization";
    }
    this.newCommentReply.organizationId = SessionHelper.getChoosenOrg();
    this.fsrv.saveComment(this.newCommentReply).pipe(untilDestroyed(this)).subscribe((pc) => {
      this.newCommentReply.commentId = pc;
      this.allcommentsList.push(
        JSON.parse(JSON.stringify(this.newCommentReply))
      );
      this.setchildcomments(this.newCommentReply.parent_comment);
      this.uievent.setProjectComments(this.newCommentReply.projectId);
      this.newCommentReply = new Projectcomment();
      this.newComment = new Projectcomment();
      //this.replymodalId ="";
      //this.placeholdertext ="Type your message here...";
      this.scrollToBottum();
      //console.log('child comment list',this.childcommentList);
    });
  }

  saveTaskComment() {
    this.newTaskComment.projectId = SessionHelper.getCurrentProject();
    this.newTaskComment.creator = SessionHelper.getUserSub();
    this.newTaskComment.related_task = this.modalTask.taskId;
    this.newTaskComment.commentvisibility = this.modalTask.taskvisibility;
    this.newTaskComment.parent_comment = "";

    this.newTaskComment.created = new Date();
    if (SessionHelper.getCustomer()) {
      this.newTaskComment.comment_type = "customer";
    } else {
      this.newTaskComment.comment_type = "organization";
    }
    this.newTaskComment.projectcomment = this.newComment.projectcomment;
    //console.log('task comment',this.newTaskComment);
    this.newTaskComment.organizationId = SessionHelper.getChoosenOrg();
    this.fsrv.saveComment(this.newTaskComment).pipe(untilDestroyed(this)).subscribe((pc) => {
      this.newTaskComment.commentId = pc;
      this.commentsList.push(this.newTaskComment);

      this.allcommentsList.push(
        JSON.parse(JSON.stringify(this.newTaskComment))
      );

      this.uievent.setProjectComments(this.newTaskComment.projectId);
      this.newTaskComment = new Projectcomment();
      this.newComment = new Projectcomment();
      this.scrollToBottum();
    });
  }

  scrollToBottum() {
    this.scollToBottomTimeout = setTimeout(() => {
      try {
        if (
          this.chatlist &&
          this.chatlist.nativeElement.scrollTop <
            this.chatlist.nativeElement.scrollHeight
        ) {
          //console.log('chat list', this.chatlist);
          this.chatlist.nativeElement.scrollTop =
            this.chatlist.nativeElement.scrollHeight;
        }
      } catch (err) {
        //console.log(err);
      }
    }, 1000);
  }

  showChat() {
    this.chatswitch = !this.chatswitch;
    if (this.chatswitch) {
      this.getChat();
      this.scrollToBottum();
    }
  }

  setComment(comment: Projectcomment) {
    this.choosenComment = comment;
  }

  showChildComments(parentcommentId: string) {
    if (this.replymodalId == "") {
      this.replymodalId = parentcommentId;
      this.setchildcomments(parentcommentId);
      this.replyOpen = true;
    } else {
      this.replymodalId = "";
      this.placeholdertext = "footer.message";
      this.childcommentList = [];
      this.replyOpen = false;
    }
  }

  setchildcomments(parentcommentId: string) {
    this.childcommentList = this.allcommentsList.filter(
      (comment) => comment.parent_comment == parentcommentId
    );
  }

  commenthasChild(commentId: string) {
    if (
      this.allcommentsList.find(
        (comment) => comment.parent_comment == commentId
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  setreplymodalId(commentId: string) {
    this.showChildComments(commentId);
    this.replymodalId = commentId;
    this.placeholdertext = "footer.reply";
  }

  changeOptions(commentId: string) {
    this.showOptions = commentId;

    if (commentId == "") {
      this.replymodalId = "";
      this.placeholdertext = "footer.message";
      this.showChildComments(commentId);
    } else {
      this.replymodalId = commentId;
      this.showChildComments(commentId);
    }
  }

  setFilterByTask(taskId: string) {
    //console.log('task id to filter: ',taskId);
    this.getChat();
    this.showFooter = true;
    this.filterByTask = true;
    this.filteredTaskId = taskId;

    var gettasks = this.datastore.taskList.getValue();
    //console.log('gettasks',gettasks);
    this.modalTask = gettasks.find((x) => this.normalizeTaskId(x.taskId) == this.normalizeTaskId(taskId));
      //this.fsrv
        // .getTask(taskId, SessionHelper.getCurrentProject())
        // .subscribe((task) => {
        //   this.modalTask = task;
        // });
    
    //Filter comments to only include comment.relatedtask = taskId
    //console.log('all comments list',this.allcommentsList);
    this.refreshVisibleComments();
  }
  
  removeFilterByTask() {
    this.filterByTask = false;
    this.filteredTaskId = '';
    this.refreshVisibleComments(false);
    this.modalTask = new Task();
    this.scrollToBottum();
  }

  canDelete(comm: Projectcomment) {
    if (
      comm.creator == SessionHelper.getUserSub() ||
      this.auth.isAuthorized("orgedit", SessionHelper.getChoosenOrg())
    ) {
      return true;
    } else {
      return false;
    }
  }

}
